/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import {
    AuthFlowType,
    CognitoIdentityProviderClient,
    InitiateAuthCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import Cookies from "js-cookie";

import { removeCookies, setCookie } from "pages/LoginWeb/utils";
import {
    ACCESS_TOKEN,
    COGNITO_CLIENT_ID,
    ID_TOKEN,
    REFRESH_TOKEN,
} from "pages/LoginWeb/constants";
import { obtainDriverAppIDToken } from "common/util";
import { configurationSlice } from "store/slices/configuration";

export const refreshAppToken = async (api: any): Promise<string | null> => {
    try {
        const newAppToken = await obtainDriverAppIDToken();
        if (newAppToken) {
            api.dispatch(configurationSlice.actions.setAuthToken(newAppToken));
            return newAppToken;
        }
    } catch (error: unknown) {
        // eslint-disable-next-line no-console
        console.error("Error refreshing app token:", error);
    }
    return null;
};

export const refreshWebToken = async (
    authConfiguration: any,
    webToken: string
): Promise<boolean> => {
    const client = new CognitoIdentityProviderClient({
        region: authConfiguration.region,
    });

    const params = {
        AuthFlow: AuthFlowType.REFRESH_TOKEN_AUTH,
        AuthParameters: {
            REFRESH_TOKEN: webToken,
        },
        ClientId: Cookies.get(COGNITO_CLIENT_ID) || "",
    };

    try {
        const command = new InitiateAuthCommand(params);
        const refreshTokenResponse = await client.send(command);
        const { AuthenticationResult } = refreshTokenResponse;

        if (AuthenticationResult?.AccessToken && AuthenticationResult.IdToken) {
            const { AccessToken, IdToken, RefreshToken } = AuthenticationResult;
            setCookie({ name: ACCESS_TOKEN, value: AccessToken });
            setCookie({ name: ID_TOKEN, value: IdToken });
            if (RefreshToken) {
                setCookie({ name: REFRESH_TOKEN, value: RefreshToken });
            }
            return true;
        } else {
            removeCookies();
        }
    } catch (error: unknown) {
        // eslint-disable-next-line no-console
        console.error("Error refreshing ID token:", error);
        removeCookies();
    }
    return false;
};
